import { Product } from '../../../../../../../graphql-api/gql-api-interfaces';
import { ExtendedBasketItem } from '../../state/reducers/basket-data.reducer';

export function countArticlesOccurrences(
  basketItems: ExtendedBasketItem[],
  product: Product,
): number {
  return basketItems
    .filter(
      (entry) =>
        entry.brandId === product.brandId &&
        entry.articleId === product.productId,
    )
    .reduce((aggr, entry) => {
      return aggr + (entry.requestedQuantity || 0) * (entry.prepackSize || 1);
    }, 0);
}
